export const PROGRESS_BAR_WIDE_MIN_WIDTH_PX = 490;

export const isProgressBarWide = (width: number): boolean =>
    width >= PROGRESS_BAR_WIDE_MIN_WIDTH_PX;

export const getVoucherSplashSize = (isWide: boolean): 'medium' | 'large' =>
    isWide ? 'large' : 'medium';

export const getVoucherSplashTop = (isWide: boolean): string => (isWide ? '-118px' : '-75px');
